import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { SettingsComponent } from '../settings.component';
import { SettingsService } from '../settings.service';
import { AppGlobalSettings, AppGlobalSettingsRequest } from '../settings';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { BaseResponse } from 'src/app/model/response/base-response';
import { environment } from 'src/environments/environment';
import { IdbService } from 'src/app/services/idb.service';

@Component({
  selector: 'app-settings-anagrafiche',
  templateUrl: './settings-anagrafiche.component.html',
  styleUrl: './settings-anagrafiche.component.scss',
  animations: [
    trigger('slideDownUp', [
      transition(':enter', [
        style({ overflow: 'hidden', width: '0', opacity: 1, height: '*' }),
        animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', width: '*', opacity: 1, height: '*' })),
      ]),
      transition(':leave', [
        style({ overflow: 'hidden', width: '*', opacity: 1, height: '*' }),
        animate('330ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', width: '0', opacity: 1, height: '*' })),
      ]),
    ]),
    trigger('slideDownUpLeave', [
      transition(':enter', [
        style({ overflow: 'hidden', opacity: 0, position: 'absolute' }),
        animate('1500ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', opacity: 1, position: 'absolute' })),
      ]),
      transition(':leave', [
        style({ overflow: 'hidden', opacity: 1, position: 'absolute' }),
        animate('1ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', opacity: 0, position: 'absolute' })),
      ]),
    ]),
  ],
})
export class SettingsAnagraficheComponent implements OnInit, OnDestroy {

  private theEnd$ = new Subject<void>();

  anagraficheViewSwitchState: boolean = false;

  showMsg: boolean = false;
  message: string = '';

  clickCounter: number = 0;
  globalSettings: AppGlobalSettings | undefined;

  ready: boolean = false;

  // settings

  constructor(
    private root: SettingsComponent,
    private settingsService: SettingsService,
    private idbService: IdbService,
  ) {

  }

  ngOnInit(): void {
    /*if(this.root.globalSettings != undefined) {
      this.anagraficheViewSwitchState = this.root.globalSettings.warningOnPiva;
    }*/
    this.updateLocalAppSettings();
  }

  updateLocalAppSettings() {

    // check if settings exist in the idb
    this.idbService.getAllData(environment.idbTables.GlobalSettings).then((res: any) => {
      console.warn("\n \n \n GOT THE DATA FROM IDB FOR SETTINGS \n \n \n");
      console.warn(res);

      if (res != undefined) {
        let resData: Array<any> = res;
        if (resData.length == 0) {
          console.warn('no data in idb')
          this.settingsService.GetSettings().pipe(takeUntil(this.theEnd$)).subscribe({
            next: (res: AppGlobalSettings) => {

              if (res != undefined) {

                // update or create settings in local idb
                this.idbService.addItemRow(environment.idbTables.GlobalSettings, res, environment.idbTables.GlobalSettings);
                this.globalSettings = res;
                this.anagraficheViewSwitchState = this.globalSettings.warningOnPiva;

              } else {
                console.error("\n \n \n \n \n SHIT \n THERE ARE NO SETTINGS 💀💀💀💀💀💀💀💀💀💀💀💀💀💀 \n \n \n \n \n");
                this.anagraficheViewSwitchState = false;
              }

              this.ready = true;

            },
            error: () => {
              this.ready = true;
            }
          });

        } else {
          console.info("SETTINGS ARE SETTED lol");
          this.globalSettings = res[0].item;
          this.anagraficheViewSwitchState = this.globalSettings!.warningOnPiva;
          this.ready = true;
        }
      } else {
        this.anagraficheViewSwitchState = false;
        this.ready = true;
      }

    });



  }


  ngOnDestroy(): void {
    this.theEnd$.unsubscribe();
  }


  switchClick() {
    console.warn("switch clicked");
  }

  saveSettings() {
    let req: AppGlobalSettingsRequest = {
      warningOnPiva: this.anagraficheViewSwitchState,
    };
    this.clickCounter++;

    if (this.clickCounter == 5) {

      this.message = "Hey, calmati. Aspetta qualche secondo prima di salvare ancora";
      this.clickCounter = 0;
      this.showMsg = true;

      setTimeout(() => {
        this.showMsg = false;
      }, 1000);

    }
    console.warn("THIS IS REQ");
    console.warn(req);
    this.settingsService.UpdateSettings(req).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (res: BaseResponse) => {

        if (res.success == true) {

          this.globalSettings!.warningOnPiva = req.warningOnPiva;

          this.message = "Impostazioni aggiornate";
          this.clickCounter = 0;
          this.showMsg = true;

          this.idbService.addItemRow(environment.idbTables.GlobalSettings, this.globalSettings, environment.idbTables.GlobalSettings);
          setTimeout(() => {
            this.showMsg = false;
          }, 1000);
        }

      },
      error: (res: BaseResponse) => {

        this.message = res.error != undefined ? res.error : "Errore durante il salvataggio, riprova più tardi";

        this.showMsg = true;

        setTimeout(() => {
          this.showMsg = false;
        }, 1000);

      }
    });
  }
}
